import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Trans } from '@lingui/macro';

import CalendarLinks from 'components/CalendarLinks';
import MainAppBar from 'components/MainAppBar';
import { Button } from 'components/ui/button';
import { getCalendarLinks, getEventById } from 'utility/requests';

export default function CalendarPage() {
    const { eventId } = useParams();
    const [calendarLinks, setCalendarLinks] = useState(null);
    const [eventTitle, setEventTitle] = useState('');
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        let active = true;

        Promise.all([getCalendarLinks(eventId), getEventById(eventId)])
            .then(([links, event]) => {
                if (!active) return;
                setCalendarLinks(links);
                setEventTitle(event.title);
                setStatus('success');
            })
            .catch(() => {
                if (active) setStatus('error');
            });

        return () => {
            active = false;
        };
    }, [eventId]);

    return (
        <div className="flex h-full flex-col bg-background text-foreground">
            <MainAppBar />
            <main className="mx-auto flex w-full max-w-xl flex-1 flex-col justify-center px-4 py-12">
                {status === 'loading' && <LoadingState />}
                {status === 'error' && <ErrorState eventId={eventId} />}
                {status === 'success' && (
                    <>
                        <p className="mb-12 text-center text-xl font-medium text-foreground">
                            {eventTitle}
                        </p>
                        <CalendarLinks links={calendarLinks} eventId={eventId} />
                    </>
                )}
            </main>
        </div>
    );
}

function LoadingState() {
    return (
        <div className="text-center text-muted-foreground">
            <Trans>Loading calendar...</Trans>
        </div>
    );
}

function ErrorState({ eventId }) {
    return (
        <div className="rounded-lg border border-border bg-card p-8 text-center shadow-sm">
            <h1 className="text-xl font-semibold">
                <Trans>Unable to load calendar</Trans>
            </h1>
            <p className="mt-3 text-muted-foreground">
                <Trans>Please try again later.</Trans>
            </p>
            <Button asChild variant="outline" className="mt-6">
                <Link
                    to={`/event/${eventId}`}
                    className="mt-6 inline-block text-sm text-primary underline-offset-4 hover:underline"
                >
                    <Trans>Back to event</Trans>
                </Link>
            </Button>
        </div>
    );
}
